/**
 * Ajuste une quantité d'ingrédient en fonction du nombre de portions.
 * Gère les quantités numériques (scalées) et textuelles (retournées brutes).
 *
 * @param {string|number} quantity - Quantité originale (ex: "200", "1 filet", null)
 * @param {number} servings - Nombre de portions souhaité
 * @param {number} baseServings - Nombre de portions de base de la recette
 * @returns {string} Quantité ajustée ou valeur brute si non numérique
 */
export const adjustQuantity = (quantity, servings, baseServings) => {
  if (!quantity) return '-';
  const numericValue = Number(quantity);
  if (isNaN(numericValue)) return String(quantity);
  const factor = servings / baseServings;
  const adjusted = numericValue * factor;
  return adjusted.toFixed(numericValue % 1 === 0 ? 0 : 1);
};
